import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Moment from 'react-moment';
import ReactHtmlParser from 'react-html-parser';

import Toast from '../commons/helpers/toast';
import { userGroupUrlCheck } from '../../utils/userGroupUrlCheck';

import { notificationsFetchAction,notificationReadAction,notificationsAllMarkAsReadAction } from '../../actions/fcmActions';  
import { NOTIFICATIONS_FETCH_SUCCESS, NOTIFICATIONS_FETCH_ERROR, NOTIFICATION_READ_SUCCESS, NOTIFICATION_READ_ERROR, NOTIFICATIONS_ALL_MARK_AS_READ_SUCCESS, NOTIFICATIONS_ALL_MARK_AS_READ_ERROR } from '../../actions';    
import { menuActiveAction } from '../../actions/commonActions'; 
import { eventPopupIdSetAction, shiftPopupIdSetAction } from '../../actions/eventActions'; 

import {URL_IMG} from '../../configs/urlConfigs'; 
import * as notifications from '../../configs/notificationConfigs'; 
import { LBL_APP_NAME, LBL_NOTIFICATIONS, LBL_UNREAD, LBL_YOUR_NOTIFICATIONS, LBL_MARK_ALL_AS_READ} from '../../configs/labelConfigs';
import { MSG_SERVER_DATA_FETCH_ERROR, MSG_NOT_FOUND, MSG_NOTIFICATION_READ_STATUS_ERROR, MSG_NOTIFICATION_ALL_MARK_AS_READ_ERROR, MSG_NOTIFICATION_ALL_MARK_AS_READ_SUCCESS } from '../../configs/msgConfigs'; 
import { LOGIN_SUPER_ADMIN_GROUP, LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP, ROUTE_AFFILIATE_REFRESH, ROUTE_CLIENT_REFRESH, ROUTE_REFRESH, RANDOM_COLORS, PAGENUMROWS_NOTIFICATIONS } from '../../configs/staticConfigs';

class NotificationComponent extends Component {
    constructor(props){
        super(props)

        this.state = {
            userGroupId : '', 
            notificationLinks: {},
            notificationCount: 0,
            unreadCount: 0,
            notificationPageSize: 0,
            arrNotificationResults: [], 
            newNotificationsCount: 0, 
            toastMessage: '',
            toastFlag: false,
            toastSuccess: true, 
            commonErrorMsg: '',
            activeUserNotifId: 0,
            activeRedirectURL: '',
            rand :Math.floor(Math.random()*RANDOM_COLORS.length),
            pageSize:PAGENUMROWS_NOTIFICATIONS,
            hasMore:false,
            currentPage: 1,
            nextPage: 1,
        }
    }

    loadNextPage = () => {
        let dataObj =  { page: this.state.nextPage, pageSize: this.state.pageSize }; 
        this.props.notificationsFetchAction(dataObj); 
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false, toastMessage:'', toastSuccess:true});
    } 

    componentDidMount() {
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }
        this.setState({userGroupId: userGroup}); 
        document.title = LBL_APP_NAME+' : '+LBL_NOTIFICATIONS;
        if(userGroup===LOGIN_AFFILIATE_GROUP){ 
            document.body.classList.add('body-affiliate'); 
        }else if(userGroup===LOGIN_CLIENT_GROUP){
            document.body.classList.add('body-client'); 
        }
        let dataObj =  { page: this.state.nextPage, pageSize: PAGENUMROWS_NOTIFICATIONS }; 
        this.props.notificationsFetchAction(dataObj); 
    }

    // readAndRedirect(item.user_notif_id,item.is_read,redirectURL+refId)

    readAndRedirect = (idValue,isRead,urlStr,menuActiveItem,refId,notifiAction) => {
        if(notifiAction===notifications.NOTIFI_ACT_TYPE_QUOTE || notifiAction===notifications.NOTIFI_ACT_TYPE_EVENT) {   
            this.props.eventPopupIdSetAction(refId)
        }
        if(notifiAction===notifications.NOTIFI_ACT_TYPE_SHIFT) {   
            this.props.shiftPopupIdSetAction(refId)
        }

        this.props.menuActiveAction(menuActiveItem); 

        if(isRead) {
            this.props.history.push(urlStr);
        }
        else if(!isRead) { 
            this.setState({activeUserNotifId:idValue, activeRedirectURL:urlStr}, () => {
                let dataObj = {id:idValue}; 
                this.props.notificationReadAction(dataObj);
            }); 
        }
    }

    onMarkAsRead = (e) => {
        this.props.notificationsAllMarkAsReadAction(); 
    }

    componentDidUpdate(prevProps) { 

        const { notificationsFetchData, notificationsFetchStatus, notificationsFetchActivity, notificationReadStatus, notificationReadActivity, notificationReadErrorData, notificationsAllReadData,notificationsAllReaStatus, notificationsAllReaActivity } = this.props; 

        if (notificationsAllReaActivity && (notificationsAllReaStatus !== prevProps.notificationsAllReaStatus || notificationsAllReaActivity !== prevProps.notificationsAllReaActivity)) { 
            var arrResp2 = notificationsAllReaActivity.split('~~'); 
            var actString2 = arrResp2[0];  
            if(notificationsAllReaStatus===200 && actString2===NOTIFICATIONS_ALL_MARK_AS_READ_SUCCESS) { 
                // RESET EVERYTHING AND CALL FIRST PAGE 
                // toastFlag:true, toastSuccess:true, toastMessage:MSG_NOTIFICATION_ALL_MARK_AS_READ_SUCCESS,
                this.setState({   
                    notificationLinks: {},
                    notificationCount: 0,
                    unreadCount: 0,
                    notificationPageSize: 0,
                    arrNotificationResults: [], 
                    newNotificationsCount: 0, 
                    commonErrorMsg: '',
                    activeUserNotifId: 0,
                    activeRedirectURL: '',
                    hasMore:false,
                    currentPage: 1,
                    nextPage: 1
                }, () => {
                    let dataObj =  { page: this.state.nextPage, pageSize: PAGENUMROWS_NOTIFICATIONS }; 
                    this.props.notificationsFetchAction(dataObj); 
                }); 

                // setTimeout(()=> {
                //     this.onCloseToast();  
                // }, 3000); 
            }
            else if(notificationsAllReaStatus!==200 || notificationsAllReaActivity===NOTIFICATIONS_ALL_MARK_AS_READ_ERROR){  
                console.log('Notification All Read Status Failed '+JSON.stringify(notificationReadErrorData)); 
                this.setState({ toastFlag:true, toastSuccess:false, toastMessage:MSG_NOTIFICATION_ALL_MARK_AS_READ_ERROR}); 
                setTimeout(()=> {
                    this.onCloseToast(); 
                }, 5000); 

            }
        }


        if (notificationReadActivity && (notificationReadStatus !== prevProps.notificationReadStatus || notificationReadActivity !== prevProps.notificationReadActivity)) { 
            var arrResp = notificationReadActivity.split('~~'); 
            var actString = arrResp[0];  
            if(notificationReadStatus===200 && actString===NOTIFICATION_READ_SUCCESS) { 
                this.props.history.push(this.state.activeRedirectURL); // REDIRECT TO THE URL 
            }
            else if(notificationReadStatus!==200 || notificationReadActivity===NOTIFICATION_READ_ERROR){  
                console.log('Notification Read Status Failed '+JSON.stringify(notificationReadErrorData)); 
                this.setState({ activeUserNotifId:0, activeRedirectURL:'', toastFlag:true, toastSuccess:false, toastMessage:MSG_NOTIFICATION_READ_STATUS_ERROR}); 
                setTimeout(()=> {
                    this.onCloseToast(); 
                }, 5000); 

            }
        }

        if (notificationsFetchActivity && (notificationsFetchStatus !== prevProps.notificationsFetchStatus || notificationsFetchActivity !== prevProps.notificationsFetchActivity)) { 
            let arrResp = (notificationsFetchActivity) ? notificationsFetchActivity.split('~~') : []; 
            let actString = arrResp[0]; 
            let links = {};
            let count = 0;
            let pageSize = 0;
            let results = []; 
            let newCount = 0; 
            let errMsg = '';
            let unreadCount = 0; 
            let hasMore = false; 
            let currentPage = this.state.currentPage; 
            let nextPage    = this.state.nextPage;  
            if(notificationsFetchStatus===200 && actString===NOTIFICATIONS_FETCH_SUCCESS) {  
                if((notificationsFetchData)) {
                    if(notificationsFetchData.results && notificationsFetchData.results.unread_count) unreadCount = notificationsFetchData.results.unread_count;
                    if(notificationsFetchData.links) links = notificationsFetchData.links;
                    if(notificationsFetchData.count) count = notificationsFetchData.count;
                    if(notificationsFetchData.page_size) pageSize = notificationsFetchData.page_size;
                    if(notificationsFetchData.results && notificationsFetchData.results.data) {
                        results = [...this.state.arrNotificationResults, ...notificationsFetchData.results.data];
                    }
                    if(results.length===0) errMsg = MSG_NOT_FOUND; 
                    if(notificationsFetchData.links && notificationsFetchData.links.next && notificationsFetchData.links.next.trim().length > 0) {
                        hasMore = true; 
                        currentPage++;
                        nextPage++; 
                    }
                }  
                this.setState({ notificationLinks:links, notificationCount:count, notificationPageSize:pageSize,
                    arrNotificationResults:results, newNotificationsCount:newCount, commonErrorMsg:errMsg, unreadCount:unreadCount, hasMore:hasMore, currentPage:currentPage, nextPage:nextPage }); 
            }
            else if(notificationsFetchStatus!==200 || actString===NOTIFICATIONS_FETCH_ERROR){  
                this.setState({ notificationLinks:links, notificationCount:count, notificationPageSize:pageSize,
                    arrNotificationResults:results, newNotificationsCount:newCount, unreadCount:unreadCount,  hasMore:hasMore, toastFlag:true, toastSuccess:false, toastMessage:MSG_SERVER_DATA_FETCH_ERROR, commonErrorMsg:MSG_NOT_FOUND }); 
                setTimeout(()=> {
                    this.onCloseToast(); 
                }, 4000); 
            } 
        }
        
    }

    render(){
        const { notificationsFetchStatus } = this.props; 
        let { hasMore } = this.state; 
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined) userGroup = userGroupData.user_group; 

        if(notificationsFetchStatus===401){ 
            if(userGroup===LOGIN_AFFILIATE_GROUP) {
                return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
            }
            else if(userGroup===LOGIN_SUPER_ADMIN_GROUP) {
                return <Redirect to={ROUTE_REFRESH} />; 
            }
            else if(userGroup===LOGIN_CLIENT_GROUP) {
                return <Redirect to={ROUTE_CLIENT_REFRESH} />; 
            }
        }
        
        const { toastMessage,toastFlag,toastSuccess,rand } = this.state; 
        //let newNotifyCount = this.state.newNotificationsCount; 
        let results = this.state.arrNotificationResults; 
        let unreadCount = this.state.unreadCount; 
        // let redirectURL = '';
        // let refId = 0;  
        // let profileImgTag = ''; 
         
        let routesObject = []; 
        if(userGroup===LOGIN_AFFILIATE_GROUP) {
            routesObject = notifications.notifiRoutesAffiliate; 
        }
        else if(userGroup===LOGIN_CLIENT_GROUP) {
            routesObject = notifications.notifiRoutesClient; 
        }

        return(
            <React.Fragment>
               
               <div className="dashboard dashboardLog">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 ">
                            <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                                <div className="box">
                                    <div className="box-head d-flex flex-row ">
                                        <div className="divFloatRight width-100-percent">
                                            {unreadCount > 0 && <div className="divFloatRight padding-top-5 padding-right-8"><Link to="#" onClick={(e) => this.onMarkAsRead(e)} >{LBL_MARK_ALL_AS_READ}</Link></div>}
                                            <div className="divFloatLeft">
                                                <h6>{LBL_YOUR_NOTIFICATIONS} {unreadCount > 0 && <span className="badge badge-secondary">{unreadCount+' '+LBL_UNREAD}</span>}</h6> 
                                            </div>

                                        </div>    
                                    </div>

                                    <div className="box-content pl-4 pr-4">
                                        <div className="row">
                                            {results.length===0 && 
                                                <div className="padding-left-10"><small className="text-muted">{this.state.commonErrorMsg}</small></div>
                                            }

                                            {results.length > 0 && results.map((item, index) => {
                                                let actVar = String(item.action); 
                                                let redirectURL = routesObject[actVar] && routesObject[actVar].length > 0 ? routesObject[actVar] : '';

                                                let refId = (item[notifications.notifiActionDictionary[item.action]]) ? item[notifications.notifiActionDictionary[item.action]] : '';
                                                let menuActiveItem = (notifications.notifiLeftMenuActiveDictionary[item.action]) ? notifications.notifiLeftMenuActiveDictionary[item.action] : '';

                                                let profileImgTag = <img className="img-fluid  img-prof-small-notification" src={require('../../'+URL_IMG+'profile-image.png')} alt={item.name} title={item.name} />; 
                                                if ((item.profile_picture) && item.profile_picture.length > 0){
                                                    profileImgTag = <img className="img-fluid  img-prof-small-notification" src={item.profile_picture} alt={item.name} title={item.name} />;
                                                }
                                                else if(((!item.profile_picture) || item.profile_picture.length===0) && item.avatar_name && item.avatar_name.length > 0) {
                                                    profileImgTag = <span title={item.name} className="img-fluid  img-prof-small-notification img-avatar" style={{background:item.profile_color}}>{item.avatar_name} </span>; 
                                                }

                                                let notifiAction = ''; 
                                                if(notifications.notifiActionTypes[item.action]) notifiAction = notifications.notifiActionTypes[item.action]; 

                                                if(redirectURL && redirectURL.length > 0) {
                                                    return(
                                                        <div key={index} className="col-md-6 col-12 p-0 notification text-muted" >
                                                            <div className={item.is_read ? "card card-m-2 p-2 d-flex flex-row greyBorder spanPointer" : "card card-m-2 p-2 d-flex flex-row bg-notify greyBorder spanPointer"} onClick={(e) => this.readAndRedirect(item.user_notif_id,item.is_read,redirectURL+refId,menuActiveItem,refId,notifiAction)} >
                                                                <div className="col-md-1 pl-0 pr-0">{profileImgTag}</div>
                                                                <div className="col-md-10 pl-2 pr-0">
                                                                        <small className="text-muted">{ReactHtmlParser(item.notification_string) }</small> 
                                                                        <h6 className="text-muted"><small><Moment fromNow>{item.created_on}</Moment></small></h6>
                                                                </div>
                                                            </div>
                                                        </div> 
                                                    )
                                                }
                                                else {
                                                    return(
                                                    <div key={index} className="col-md-6 col-12 p-0 notification text-muted" >
                                                            <div className={item.is_read ? "card card-m-2 p-2 d-flex flex-row greyBorder" : "card card-m-2 p-2 d-flex flex-row bg-notify greyBorder"}>
                                                                <div className="col-md-1 pl-0 pr-0">{profileImgTag}</div>
                                                                <div className="col-md-10 pl-2 pr-0">
                                                                        <small className="text-muted">{ReactHtmlParser(item.notification_string) }</small> 
                                                                        <h6 className="text-muted"><small><Moment fromNow>{item.created_on}</Moment></small></h6>
                                                                </div>
                                                            </div>
                                                        </div> 
                                                    )
                                                }
                                                

                                                // return(
                                                //     <div key={index} className="col-md-6 col-12 p-0 notification text-muted spanPointer">
                                                //         <div className={item.is_read ? "card m-2 p-2 d-flex flex-row greyBorder" : "card m-2 p-2 d-flex flex-row bg-notify greyBorder"}>
                                                //             <div className="col-md-1 pl-0 pr-0">{profileImgTag}</div>
                                                //             <div className="col-md-10 pl-2 pr-0">
                                                //                 <div>   
                                                //                     {redirectURL && redirectURL.length > 0 && <span onClick={(e) => this.readAndRedirect(item.user_notif_id,item.is_read,redirectURL+refId)}><small className="text-muted spanPointer">{ReactHtmlParser(item.notification_string) }</small></span>}
                                                                    
                                                //                     {redirectURL && redirectURL.length===0 && <small className="text-muted">{ReactHtmlParser(item.notification_string) }</small>}
                                                //                     <h6 className="text-muted"><small><Moment fromNow>{item.created_on}</Moment></small></h6>
                                                //                 </div>
                                                //             </div>
                                                //         </div>
                                                //     </div> 
                                                // )
                                            })}
                                            { hasMore &&
                                            <div className="col-12 hasMoreNotifications" >
                                                <Link to="#" onClick={this.loadNextPage} >View more</Link>
                                            </div>
                                            }  
                                            
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>                
                    </div>
                </div>
            </React.Fragment>    
        )
    }
}

const mapStateToProps = (state) => {
    return {
        notificationsFetchData:state.fcmNotifiToken.notificationsFetchData,
        notificationsFetchStatus:state.fcmNotifiToken.notificationsFetchStatus,
        notificationsFetchActivity:state.fcmNotifiToken.notificationsFetchActivity,
        notificationsFetchErrorData:state.fcmNotifiToken.notificationsFetchErrorData,
        notificationReadStatus:state.fcmNotifiToken.notificationReadStatus,
        notificationReadActivity:state.fcmNotifiToken.notificationReadActivity,
        notificationReadErrorData:state.fcmNotifiToken.notificationReadErrorData, 
        notificationsAllReadData:state.fcmNotifiToken.notificationsAllReadData,
        notificationsAllReaStatus:state.fcmNotifiToken.notificationsAllReaStatus,
        notificationsAllReaActivity:state.fcmNotifiToken.notificationsAllReaActivity,
    }
}  

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        notificationsFetchAction:notificationsFetchAction,
        notificationReadAction:notificationReadAction,
        notificationsAllMarkAsReadAction:notificationsAllMarkAsReadAction,
        menuActiveAction:menuActiveAction, 
        eventPopupIdSetAction:eventPopupIdSetAction,
        shiftPopupIdSetAction:shiftPopupIdSetAction, 
    },dispatch);
}               

export default connect(mapStateToProps,mapDispatchToProps)(NotificationComponent);

